export default function setupWobbleGui({ gui, wobble, label })
{
  const folder = gui.addFolder(label)

  folder.add(wobble.uniforms.uPositionFrequency, 'value', 0, 2, 0.001).name('Position Frequency')
  folder.add(wobble.uniforms.uTimeFrequency, 'value', 0, 2, 0.001).name('Time Frequency')
  folder.add(wobble.uniforms.uStrength, 'value', 0, 2, 0.001).name('Strength')

  folder.add(wobble.uniforms.uWarpPositionFrequency, 'value', 0, 2, 0.001).name('Warp Position Frequency')
  folder.add(wobble.uniforms.uWarpTimeFrequency, 'value', 0, 2, 0.001).name('Warp Time Frequency')
  folder.add(wobble.uniforms.uWarpStrength, 'value', 0, 2, 0.001).name('Warp Strength')

  folder.addColor(wobble.debugObject, 'colorA').onChange(() =>
  {
    wobble.uniforms.uColorA.value.set(wobble.debugObject.colorA)
  })

  folder.addColor(wobble.debugObject, 'colorB').onChange(() =>
  {
    wobble.uniforms.uColorB.value.set(wobble.debugObject.colorB)
  })

  folder.close()

  return folder
}
